'use strict';

import React, { Component } from 'react'

import Slider from 'react-slick'

import _ from 'lodash'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import HolidaysMessage from '@/HolidaysMessage'

import Layout from '@Layout/ECFront'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'
import Link   from '@Pure/Link'

import getUrlParameter from '@function/getUrlParameter'

const moment = window.moment;

moment.locale('fr');

const app = window.app;

const qwest = window.qwest;

const base_video_url = 'https://www.youtube-nocookie.com/embed/';

export default class BlogPage extends Component
{
	state =
	{
		article: { },
		references: [],
		loading: false
	};

	componentDidUpdate ()
	{
		if (window.objectFitImages instanceof Function)
		{
			window.objectFitImages();
		}
	}

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props;

		app.resetFunctions();

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		let filter_query =
		{
			id: id
		};

		component.setState(
		{
			loading: true
		});

		qwest.post('/CMS/getAll',
		{
			model: 'adblog',
			filter_query: JSON.stringify(filter_query)
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				article: response.data[0] || { },
				loading: false
			});
		})
		.catch(function (error, xhr, response)
		{
			component.setState(
			{
				loading: false
			});

			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	render ()
	{
		const component = this, props = this.props, article = component.state.article;

		const state = this.state;

		let loader;

		if (component.state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['primary', 'bg-white', 'big'] } />;
		}

		let images = (article.images || []).map(function (data, index)
		{
			var output =
			(
				<div key={ index }>
					<Image className="c-model__carousel-image" src={ data.url }
						force-local
					/>
				</div>
			);

			return output;
		});

		const slider_settings =
		{
			dots: true,
			infinite: false,
			speed: 320,
			slidesToShow: 1,
			slidesToScroll: 1,
			swipeToSlide: true,
			useCSS: true,
			breakpoint: 100,
			draggable: true
		};

		let slider;

		if (images.length)
		{
			slider =
			(
				<div className="o-grid__item-5">

					<div className="c-model__images">
						<Slider { ...slider_settings }>
							{ images }
						</Slider>
					</div>

				</div>
			);
		}

		let date;

		if (article.date)
		{
			date = moment(article.date).format('DD MMMM YYYY');
		}

		let content = (article.content || '').split('<p><br></p>').join('');

		let pdf_files = (article.pdfs || [])
		.filter(data => Boolean(data))
		.map(function (file, i)
		{
			let output =
			(
				<div className="u-full-width u-margin-top-10" key={ i }>
					<Link href={ file.url } type="application/pdf" target="_blank">
						{ file.filename }
					</Link>
				</div>
			);

			return output;
		});

		let pdf_files_title;

		if (pdf_files.length > 0)
		{
			pdf_files_title =
			(
				<div className="c-subtitle u-margin-top-30">
					<div className="c-subtitle__txt">
						Pièces jointes
					</div>
				</div>
			);
		}

		let video_id = state.article?.youtube
		? getUrlParameter('v', state.article.youtube)
		: undefined;

		const video = video_id ?
		(
			<div className="c-model__video-container u-margin-top-20">

				<iframe className="c-model__video" width="560" height="315"
				src={ base_video_url + video_id + '?rel=0' }
				title="YouTube video player"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>

			</div>
		)
		: undefined;

		let output =
		(
			<Layout page_title={ article.title || 'Article' }
				history={ props.history }>

				<div className="page-content c-model c-model--article">

					<HolidaysMessage />

					<div className="o-grid">

						{ slider }

						<div className={ slider ? 'o-grid__item-7' :
							'o-grid__item-12 u-full-width' }>

							<div className="c-title u-no-margin-top">
								<h2 className="c-title__txt">
									{ article.title }
								</h2>
							</div>

							<div className="c-model__body">

								<div className="c-model__themes">
									<div className="c-model__theme">
										{ date }
									</div>
								</div>

								<div className="c-model__description"
									dangerouslySetInnerHTML={ { __html: content } }>
								</div>

								{ pdf_files_title }

								{ pdf_files }

								{ video }

							</div>

						</div>

						{ loader }

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}
